module.exports = __webpack_public_path__ + "img/t1.0b140c2d.png";